import { extendObservable, computed } from 'mobx'

class Project {
  constructor (projectData, staticData) {
    extendObservable(this, {
      ...projectData,
      status: computed(
        () => staticData.names.projectStatuses[this.projectStatusId]
      ),
      type: computed(() => staticData.names.projectTypes[this.projectTypeId]),
      industry: computed(() => staticData.names.industries[this.industryId]),
      subIndustry: computed(
        () => staticData.names.subIndustries[this.subIndustryId]
      ),
      isOpen: computed(
        () => this.projectStatusId === staticData.CONST.PROJECT_STATUSES.OPEN
      ),
      isClosed: computed(
        () => this.projectStatusId === staticData.CONST.PROJECT_STATUSES.CLOSED
      )
    })
  }
}

export default Project
